import { useState } from "react";

const ForgotPasswordCode = () => {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [step, setStep] = useState("request");

  const handleSendCode = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      const res = await fetch("/api/auth/send-reset-code", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (res.ok) {
        setStep("reset");
        setMessage("Password reset code sent! Check your email.");
      } else {
        setMessage(data.message || "Failed to send code.");
      }
    } catch (err) {
      setMessage("Failed to send code.");
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      const res = await fetch("/api/auth/reset-password-with-code", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, code, newPassword })
      });
      const data = await res.json();
      if (res.ok) {
        setMessage("✅ Password reset! You can now log in.");
        setStep("done");
      } else {
        setMessage(data.message || "Password reset failed.");
      }
    } catch (err) {
      setMessage("Password reset failed.");
    }
  };

  return (
    <div className="form-container">
      <h2>Forgot Password</h2>
      {step === "request" && (
        <form onSubmit={handleSendCode}>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            placeholder="Enter your email"
          />
          <button type="submit">Send Reset Code</button>
        </form>
      )}
      {step === "reset" && (
        <form onSubmit={handleResetPassword}>
          <input
            type="text"
            value={code}
            onChange={e => setCode(e.target.value)}
            required
            placeholder="Enter reset code"
          />
          <input
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            required
            placeholder="Enter new password"
          />
          <button type="submit">Reset Password</button>
        </form>
      )}
      {message && <p>{message}</p>}
    </div>
  );
};

export default ForgotPasswordCode;
